// What a permission cell renders; MIXED only occurs on a rolled-up row whose devices disagree.
enum PermissionStatus {
  DENIED = "denied",
  GRANTED = "granted",
  MIXED = "mixed",
  NOT_APPLICABLE = "notApplicable",
  UNKNOWN = "unknown",
}

export default PermissionStatus;
